import { useEffect, useState } from 'react';
import { addQueryParam } from '../../utils/navigation';

export interface UseUpgradeCompleteStepOptions {
    onModalShow: () => void;
}

export const UPGRADE_SOURCE_QUERY_KEY = 'upgrade_source';
export const SELLER_ID_QUERY_KEY = 'seller_id';
export const WAS_UPGRADED_QUERY_KEY = 'upgradePlan';
export const SELLER_NAME_QUERY_KEY = 'seller_name';

export const setUpgradeQueryParams = (id: number, name: string, source: string) => {
    if (typeof window === 'undefined') return;
    const withUpgrade = addQueryParam(window?.location.href, WAS_UPGRADED_QUERY_KEY, 'true');
    const withSource = addQueryParam(withUpgrade, UPGRADE_SOURCE_QUERY_KEY, source);
    const withSellerName = addQueryParam(withSource, SELLER_NAME_QUERY_KEY, name);
    const withSellerId = addQueryParam(withSellerName, SELLER_ID_QUERY_KEY, id?.toString() || '');
    return withSellerId;
};

export const useUpgradeCompleteStep = ({ onModalShow }: UseUpgradeCompleteStepOptions) => {
    const [upgradeSource, setUpgradeSource] = useState('');
    const [sellerId, setSellerId] = useState('');
    const [sellerName, setSellerName] = useState('');

    useEffect(() => {
        const url = new URL(window?.location.href);
        if (url.searchParams.get(UPGRADE_SOURCE_QUERY_KEY)) {
            setUpgradeSource(url.searchParams.get(UPGRADE_SOURCE_QUERY_KEY) || '');
            setSellerId(url.searchParams.get(SELLER_ID_QUERY_KEY) || '');
            setSellerName(url.searchParams.get(SELLER_NAME_QUERY_KEY) || '');
            onModalShow();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        upgradeSource,
        sellerId,
        sellerName,
    };
};
